import { Modal } from '@trackman/web-shared-components';
import { SUPPORT_EMAIL, SUPPORT_PHONE_NUMBER, SUPPORT_URL } from 'constants/SupportPhoneNumber';
import { ReactComponent as ExternalIcon } from 'images/externalIcon.svg';
import React from 'react';
import { ExternalLink, Hint, ItemLabel, ItemValue, ModalContent, ModalItem, SupportCenter, SupportWrapper } from './FaqModalStyles';

interface IProps {
  visible: boolean;
  onDismissCallback: () => void;
}

const FaqModal: React.FC<IProps> = (props) => {
  const { visible, onDismissCallback } = props;
  return (
    <Modal
      open={visible}
      onClose={onDismissCallback}
      title='Need help?'
      maxWidth='xs'
      fullWidth
      confirmBtn={{
        label: 'Close',
        intent: 'primary',
        onClick: () => {
          onDismissCallback();
        },
      }}
    >
      <ModalContent>
        <ModalItem>
          <ItemLabel>Browse guides and FAQs</ItemLabel>
          <SupportWrapper>
            <ExternalLink href={SUPPORT_URL} target='_blank'>
              <SupportCenter>Support Center</SupportCenter>
              <ExternalIcon />
            </ExternalLink>
            <Hint>Internet required</Hint>
          </SupportWrapper>
        </ModalItem>
        <ModalItem>
          <ItemLabel>Call support</ItemLabel>
          <ItemValue>{SUPPORT_PHONE_NUMBER}</ItemValue>
        </ModalItem>
        <ModalItem>
          <ItemLabel>Email support</ItemLabel>
          <ItemValue>{SUPPORT_EMAIL}</ItemValue>
        </ModalItem>
      </ModalContent>
    </Modal>
  );
};

export default FaqModal;
